import { Component, EventEmitter, Input, OnInit, Optional, Output, forwardRef } from '@angular/core';
import { ControlContainer, FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseFpxFormComponent } from '@fpx/core';
import { ProfilepicResultFormHelper, ProfilepicResultFormState } from './profile-pic-result-form.helper';
import { ProfilepicResultFormService } from './profile-pic-result-form.service';
import { ResponsiveService } from 'src/app/responsive.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-profile-pic-result-form',
  templateUrl: './profile-pic-result-form.component.html',
  styleUrls: ['./profile-pic-result-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProfilePicResultFormComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ProfilePicResultFormComponent),
      multi: true,
    },
    ProfilepicResultFormHelper,ProfilepicResultFormService
  ]
})
export class ProfilePicResultFormComponent extends BaseFpxFormComponent<ProfilepicResultFormHelper,ProfilepicResultFormState> {
  @Input () imageData:string;
  @Output () retake:EventEmitter<any> = new EventEmitter();
  @Output () onSubmit:EventEmitter<any> = new EventEmitter();
  constructor(
    @Optional() _controlContainer: ControlContainer,
    _formBuilder: FormBuilder,
    private _router: Router,
    private _profilepicResultHelper:ProfilepicResultFormHelper,
    protected _responsive : ResponsiveService,
    private dialogRef:MatDialogRef<any>
  ) { 
    super(_formBuilder, _router, _controlContainer,_profilepicResultHelper);
  }

  protected doPreInit(): void {
    //this.setDataService(this._selfieResultService);
  }
  closePopup(){
    this.dialogRef.close();
  }

}
